/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";

const PageHeader = (props) => {
	let { pageTitle, pageDescription } = props;
	const pageDescriptionComp = React.isValidElement(pageDescription) ? (
		pageDescription
	) : (
		<span className="text-muted">{pageDescription}</span>
	);
	return (
		<div>
			{pageTitle && <h4 style={{ fontWeight: "bold" }}>{pageTitle}</h4>}
			{pageDescription && pageDescriptionComp}
		</div>
	);
};
export default PageHeader;
